<!--
 * @Author: gaoxueting
 * @Date: 2020-06-04 06:40:49
 * @LastEditTime: 2020-08-12 18:16:04
 * @LastEditors: fengzhongmei
 * @Description:
 * @FilePath: /rightcloud-console2/src/views/modules/cloudmgt/env/components/acl/aclrule.vue
-->
<template>
    <div class="env-subnet">
        <rcTable ref="rcTable"
                 :tableAttr="tableAttr">
            <Button slot="tootipL"
                    @click="refreshTable">
                <i class="icon-refresh-o-2"></i>
            </Button>
            <Button type="primary"
                    @click="addRulesFun"
                    v-if="hasPermission('CB090506')"
                    slot="tootipL">
                <i class="icon-plus-o-1"></i><span>{{$t('创建规则')}}</span>
            </Button>
        </rcTable>
        <createrule ref="createrule"
                    :ruletype="ruletype"
                    :direction="direction"
                    :baseInfo="baseInfo"
                    @refreshTable="refreshTable"></createrule>
    </div>
</template>

<script>
import rcTable from '@c/basic/rcTable'
import createrule from './createrule.vue'
import API from '@/service/api.js'
import dropdownlist from '@c/basic/dropdownlist'
export default {
    name: 'subnet',
    props: ['type', 'baseInfo', 'id', 'envId'],
    components: {
        rcTable,
        createrule
    },
    data () {
        return {
            // 是否显示table，依据是否给url&params赋值
            // showTable: false,
            noChange: true,
            modalEdit: false,
            formData: {
                description: ''
            },
            // 需要克隆的数据
            cloneData: {},
            securityId: '',
            ruletype: '',
            direction: '',
            tableAttr: {
                source: {
                    type: 'get',
                    url: this.urlFormat(API.GET_ACL_RULE, false),
                    params: {
                        firewallPolicyId: this.type !== 'ingress' ? this.baseInfo.egressFirewallPolicyId : this.baseInfo.ingressFirewallPolicyId // 传入前者得到入方向规则列表，后者得到出方向规则列表)
                    }
                },
                searchColumns: [
                    {
                        key: 'action',
                        title: this.$i18n.t('所有动作'),
                        searchDefaultValue: '',
                        searchType: 'select',
                        searchData: [
                            { name: '允许', value: 'allow' },
                            { name: '拒绝', value: 'deny' }
                        ]
                    },
                    {
                        key: 'protocol',
                        title: this.$i18n.t('所有协议'),
                        searchDefaultValue: '',
                        searchType: 'select',
                        searchData: [
                            { name: 'TCP', value: 'tcp' },
                            { name: 'UDP', value: 'udp' },
                            { name: 'ICMP', value: 'icmp' },
                            { name: '全部', value: 'all' }
                        ]
                    },
                    {
                        key: 'sourceUrl',
                        title: this.$t('源地址'),
                        searchDefaultValue: ''
                    },
                    {
                        key: 'targetUrl',
                        title: this.$t('目的地址'),
                        searchDefaultValue: ''
                    }
                ],
                searchShow: true,
                isMultiSelect: false,
                columnsChooseShow: true,
                columns: []
            },
            editData: {},
            envType: this.$route.query.envType,
            columns: [
                {
                    title: this.$t('优先级'),
                    key: 'priorityLevel',
                    className: 'ellipsis',
                    columnShow: true,
                    disabledSearch: true,
                    columnsChoosed: true
                },
                {
                    title: this.$t('状态'),
                    key: 'status',
                    className: 'ellipsis',
                    columnShow: true,
                    disabledSearch: true,
                    columnsChoosed: true,
                    render: (h, params) => {
                        return h('div', [
                            h('span', { style: (params.row.status === 'true' ? 'color:#1ebd62' : 'display:none') }, this.$t('启用')),
                            h('span', { style: (params.row.status !== 'true' ? 'color:#ef4235' : 'display:none') }, this.$t('禁用'))
                        ])
                    }
                },
                {
                    title: this.$t('策略'),
                    key: 'action',
                    className: 'ellipsis',
                    columnShow: true,
                    disabledSearch: true,
                    columnsChoosed: true,
                    render: (h, params) => {
                        const txt = params.row.action === 'allow' ? '允许' : '禁用'
                        return h('span', { attrs: { title: this.$t(txt) } }, this.$t(txt))
                    }
                },
                {
                    title: this.$t('协议'),
                    key: 'protocol',
                    className: 'ellipsis',
                    columnShow: true,
                    disabledSearch: true,
                    columnsChoosed: true,
                    render: (h, params) => {
                        return h('span', { attrs: { title: params.row.protocol } }, params.row.protocol)
                    }
                },
                {
                    title: this.$t('源地址'),
                    key: 'sourceUrl',
                    className: 'ellipsis',
                    columnShow: true,
                    disabledSearch: true,
                    columnsChoosed: true,
                    render: (h, params) => {
                        return h('span', { attrs: { title: params.row.sourceUrl } }, params.row.sourceUrl)
                    }
                },
                {
                    title: this.$t('源端口范围'),
                    key: 'sourcePort',
                    className: 'ellipsis',
                    columnShow: true,
                    disabledSearch: true,
                    columnsChoosed: true,
                    render: (h, params) => {
                        return h('span', { attrs: { title: params.row.sourcePort } }, params.row.sourcePort)
                    }
                },
                {
                    title: this.$t('目的地址'),
                    key: 'targetUrl',
                    className: 'ellipsis',
                    columnShow: true,
                    disabledSearch: true,
                    columnsChoosed: true,
                    render: (h, params) => {
                        return h('span', { attrs: { title: params.row.targetUrl } }, params.row.targetUrl)
                    }
                },
                {
                    title: this.$t('目的端口范围'),
                    key: 'targetPort',
                    className: 'ellipsis',
                    columnShow: true,
                    disabledSearch: true,
                    columnsChoosed: true,
                    render: (h, params) => {
                        return h('span', { attrs: { title: params.row.targetPort } }, params.row.targetPort)
                    }
                },
                {
                    title: this.$t('描述'),
                    key: 'description',
                    className: 'ellipsis',
                    columnShow: true,
                    disabledSearch: true,
                    columnsChoosed: true,
                    render: (h, params) => {
                        return h('span', { attrs: { title: params.row.description } }, params.row.description)
                    }
                },
                {
                    title: this.$t('操作'),
                    width: 190,
                    render: (h, params) => {
                        let arr = [
                            h('a', { class: { disabled: !this.hasPermission('CB090507') }, on: { click: () => this.hasPermission('CB090507') && this.editFun(params.row) } }, this.$t('编辑')),
                            h('a', { class: { disabled: !this.hasPermission('CB090508') }, on: { click: () => this.hasPermission('CB090508') && this.deleteFun(params.row) } }, this.$t('删除'))
                        ]

                        const per = this.hasPermission('CB0905') || this.hasPermission('CB090507')
                        arr = arr.concat([
                            per && h(dropdownlist, {
                                props: {
                                    operateConfig: this.configBtn(params.row)
                                },
                                style: 'cursor:pointer;display:inline-block;margin-left: 5px;',
                                on: { event: (type) => { this.operate(type, params.row) } }
                            })
                        ])
                        return h('div', {
                            class: 'tbl-btn-div'
                        }, arr)
                    }
                }
            ]
        }
    },
    created () {
        this.tableAttr.source.params = {
            firewallPolicyId: this.type !== 'ingress' ? this.baseInfo.egressFirewallPolicyId : this.baseInfo.ingressFirewallPolicyId // 传入前者得到入方向规则列表，后者得到出方向规则列表)
        }
        this.handleDifEnv()
    },
    methods: {
        // 不同云环境下显示的表格列名不同
        handleDifEnv () {
            this.tableAttr.columns = [...this.columns].filter(col => {
                let res = false
                if (!col.excludeEnvs && !col.supportEnvs) {
                    res = true
                } else if (col.supportEnvs && col.supportEnvs.includes(this.envType)) {
                    res = true
                } else if (col.excludeEnvs && !col.excludeEnvs.includes(this.envType)) {
                    res = true
                }
                return res
            })
        },
        refreshTable () {
            this.$refs.rcTable && this.$refs.rcTable.refreshTable()
        },
        // 生成更多按钮
        configBtn: function (obj) {
            const btnConfig = []
            if (this.hasPermission('CB090507')) {
                btnConfig.push({ value: 'insertBefore', btnName: this.$t('向前插入规则'), display: true, disabled: !this.hasPermission('CB0905') })
                btnConfig.push({ value: 'insertAfter', btnName: this.$t('向后插入规则'), display: true, disabled: !this.hasPermission('CB0905') })
            }
            if (this.hasPermission('CB090507') && obj.status === 'true') {
                btnConfig.push({ value: 'closeRule', btnName: this.$t('关闭'), display: true, disabled: !this.hasPermission('CB0905') })
            }
            if (this.hasPermission('CB090507') && obj.status === 'false') {
                btnConfig.push({ value: 'closeRule', btnName: this.$t('开启'), display: true, disabled: !this.hasPermission('CB0905') })
            }

            return JSON.stringify(btnConfig)
        },
        // 更多按钮事件分发
        operate (operateType, row) {
            switch (operateType) {
                case 'insertBefore':
                    this.insertBefore(row)
                    break
                case 'insertAfter':
                    this.insertAfter(row)
                    break
                case 'closeRule':
                    this.closeRule(row)
                    break
            }
        },
        // 添加规则
        addRulesFun () {
            if (!this.hasPermission('CB090506')) return
            this.$nextTick(() => {
                this.ruletype = 'add'
                this.direction = this.type
                this.$refs.createrule.openModal()
            })
        },
        insertBefore (row) {
            this.$nextTick(() => {
                this.ruletype = 'insertBefore'
                this.direction = this.type
                this.$refs.createrule.openModal(row)
            })
        },
        insertAfter (row) {
            this.$nextTick(() => {
                this.ruletype = 'insertAfter'
                this.direction = this.type
                this.$refs.createrule.openModal(row)
            })
        },
        editFun (row) {
            if (!this.hasPermission('CB090507')) return
            this.$nextTick(() => {
                this.ruletype = 'edit'
                this.direction = this.type
                this.$refs.createrule.openModal(row)
            })
        },
        deleteFun (row) {
            if (!this.hasPermission('CB090508')) return
            this.$Modal.confirm({
                title: this.$t('删除'),
                content: this.$t('确认要删除该规则?'),
                onOk: () => {
                    this.axios.delete(this.urlFormat(API.POST_ACL_RULE, false) + '/' + row.id).then(res => {
                        this.refreshTable()
                    })
                }
            })
        },
        closeRule (row) {
            if (!this.hasPermission('CB090507')) return
            const obj = {
                id: row.id,
                name: row.name,
                status: false
            }
            let message = '<b>确定要关闭该规则吗？</b><br>关闭网络ACL规则会导致该网络ACL规则不生效。'
            if (row.status === 'false') {
                message = '<b>确定要开启该规则吗？</b>'
                obj.status = true
            }
            this.$Modal.confirm({
                title: row.status === 'false' ? this.$t('开启') : this.$t('关闭'),
                content: message,
                onOk: () => {
                    this.axios.put(this.urlFormat(API.POST_ACL_RULE, false), obj).then(res => {
                        this.refreshTable()
                    })
                }
            })
        },
        isNullOrUndefined (val) {
            if (val === null || val === undefined) {
                return true
            }
        }
    }
}
</script>
